$('.wc-desc-toggle-wrap').each(function() {
    var $wrap = $(this);
    var $btn = $wrap.find('.wc-desc-more-btn');
    var $rest = $wrap.find('.wc-desc-rest');
    $btn.on('click', function() {
        $rest.slideDown();
        $btn.hide();
    });
});

